import React from 'react'
import { useAppContext } from '../../../context/appContext';
import { TextMd, TextSm } from '../../../components/text';
import { SeeMore } from '../../home/components/seeMore';

export const ApiDevelopment = ({ className="" }) => {
  const { routing } = useAppContext();
  const { navigate } = routing;

  return (
    <button
      className={`w-full flex flex-col items-center gap-8 text-left ${className}`}
    >
      <div className="w-full flex flex-col">
        <TextSm className="uppercase whitespace-nowrap tracking-[0.1em] text-blue-500 font-semibold">
          API Development
        </TextSm>

        <TextMd className="font-semibold text-slate-900 mb-4">
          Connecting systems with secure and reliable data flows.
        </TextMd>

        <TextSm className="text-slate-500 leading-7 mb-8">
          APIs make it possible for applications, services, and business
          tools to communicate clearly, securely, and efficiently across
          your software ecosystem.
        </TextSm>

        <div className="flex flex-wrap gap-x-8 gap-y-3">
          <div className="flex items-center gap-3 text-slate-700">
            <div className="h-1.5 w-1.5 rounded-full bg-blue-500" />
            <TextSm>REST & GraphQL APIs</TextSm>
          </div>
          
          <div className="flex items-center gap-3 text-slate-700">
            <div className="h-1.5 w-1.5 rounded-full bg-blue-500" />
            <TextSm>Authentication</TextSm>
          </div>

          <div className="flex items-center gap-3 text-slate-700">
            <div className="h-1.5 w-1.5 rounded-full bg-blue-500" />
            <TextSm>Third-Party Integrations</TextSm>
          </div>
        </div>
      </div>
    </button>
  )
}
